export type AddressFormType = {
  line1: string
  line2: string
  city: string
  state: string
  postalCode: string
}

export type AddressFormErrorType = {
  line1: boolean
  city: boolean
  state: boolean
  postalCode: boolean
}

export interface FhirAddress {
  city?: string
  country?: string
  id?: string
  line?: string[]
  postalCode?: string
  state?: string
  text?: string
  type?: string
  use?: string
}

export interface Coding {
  code?: string
  display?: string
  id?: string
  system?: string
  userSelected?: boolean
  version?: string
}

export interface CodeableConcept {
  coding?: Coding[]
  id?: string
  text?: string
}

export interface Identifier {
  assigner?: Reference
  id?: string
  system?: string
  type?: CodeableConcept
  use?: string
  value?: string
}

export interface ResourceObject {
  id?: string
  implicitRules?: string
  language?: string
  resourceType?: string
}

export const isResourceObject = (
  resource?: any[] | boolean | number | number | null | ResourceObject | string,
): resource is ResourceObject => !!(resource && typeof (resource as ResourceObject).resourceType === "string")

export interface Reference {
  display?: string
  id?: string
  identifier?: Identifier
  localRef?: string
  resource?: any[] | boolean | number | number | null | ResourceObject | string
  resourceType?: string
  type?: string
  uri?: string
}

export interface Parameters {
  id?: string
  implicitRules?: string
  language?: string
  parameter?: ParametersParameterArrayArray[]
  resourceType?: "Parameters"
}

export interface ParametersParameterArrayArray {
  id?: string
  name: string
  part?: ParametersParameterArrayArray[]
  resource?: any[] | boolean | number | number | null | ResourceObject | string
  value?: ParametersParameterArrayValue
}

export interface ParametersParameterArrayValue {
  Address?: FhirAddress
  base64Binary?: string
  boolean?: boolean
  canonical?: string
  code?: string
  CodeableConcept?: CodeableConcept
  Coding?: Coding
  date?: string
  dateTime?: string
  decimal?: number
  id?: string
  Identifier?: Identifier
  instant?: Date
  integer?: number
  markdown?: string
  oid?: string
  positiveInt?: number
  Range?: Range
  Reference?: Reference
  string?: string
  time?: string
  unsignedInt?: number
  uri?: string
  url?: string
  uuid?: string
}

export type CustomError = Error & { cause: { name: string; message: string; issues?: string[]; traceId?: string } }

export interface Extension {
    extension?: Extension[]
    id?: string
    modifierExtension?: Extension[]
    url?: string
    valueAddress?: any
    valueAge?: any
    valueAnnotation?: any
    valueAttachment?: any
    valueBase64Binary?: string
    valueBoolean?: boolean
    valueCanonical?: string
    valueCode?: string
    valueCodeableConcept?: any
    valueCoding?: any
    valueContactDetail?: any
    valueContactPoint?: any
    valueContributor?: any
    valueCount?: any
    valueDataRequirement?: any
    valueDate?: string
    valueDateTime?: string
    valueDecimal?: number
    valueDistance?: any
    valueDosage?: any
    valueDuration?: any
    valueElementDefinition?: any
    valueEmail?: string
    valueExpression?: any
    valueHumanName?: any
    valueId?: string
    valueIdentifier?: any
    valueInstant?: Date
    valueInteger?: number
    valueKeyword?: string
    valueMap?: any
    valueMarkdown?: string
    valueMarketingStatus?: any
    valueMeta?: any
    valueMoney?: any
    valueMoneyQuantity?: any
    valueNarrative?: any
    valueNumber?: number
    valueOid?: string
    valueParameterDefinition?: any
    valuePassword?: string
    valuePeriod?: any
    valuePopulation?: any
    valuePositiveInt?: number
    valueProdCharacteristic?: any
    valueProductShelfLife?: any
    valueQuantity?: any
    valueRange?: any
    valueRatio?: any
    valueReference?: any
    valueRelatedArtifact?: any
    valueSampledData?: any
    valueSearchParameterExpression?: any
    valueSignature?: any
    valueSimpleQuantity?: any
    valueString?: string
    valueSubstanceAmount?: any
    valueTime?: string
    valueTiming?: any
    valueTriggerDefinition?: any
    valueUnsignedInt?: number
    valueUri?: string
    valueUrl?: string
    valueUsageContext?: any
    valueUuid?: string
    valueXhtml?: string
    type?: string
}

export interface OperationOutcomeIssueArray {
    code: string
    details?: CodeableConcept
    diagnostics?: string
    expression?: string[]
    extension?: Extension[]
    id?: string
    location?: string[]
    modifierExtension?: Extension[]
    severity: string
}
export interface Narrative {
    div: string
    extension?: Extension[]
    id?: string
    modifierExtension?: Extension[]
    status: string
}

export interface OperationOutcome {
    contained?: Array<any[] | boolean | number | number | null | ResourceObject | string>
    extension?: Extension[]
    id?: string
    implicitRules?: string
    issue: OperationOutcomeIssueArray[]
    language?: string
    modifierExtension?: Extension[]
    resourceType?: "OperationOutcome"
    text?: Narrative
}

export const isOperationOutcome = (
    resource?: any[] | boolean | number | number | null | ResourceObject | string,
): resource is OperationOutcome => isResourceObject(resource) && resource.resourceType === "OperationOutcome"
